import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { removeNotification } from '@app/core/store/actions/notifications.actions';
import { Notification } from '@core/models/notification/notification';
import { NotificationTypes } from '@core/models/notification/notification-types';
import { AppState } from '@core/store/reducers';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-notification',
  template: `
    <ngb-alert #alert [dismissible]="notification?.dismissible" (closed)=close() [type]="notification?.type" class="{{extraCss}}" >
      <i class="alert-icon material-icons-round">{{iconName}}</i>
      <div class="alert-content" *ngIf="notification?.listItems; else textOnly">
        <div [innerHtml]="notification?.text"></div>
          <ul class="mb-0">
            <li *ngFor="let item of notification?.listItems"><div class="borderless" [innerHtml]="item"></div></li>
          </ul>
      </div>
      <ng-template #textOnly>
        <div class="alert-content" [innerHtml]="notification?.text"></div>
      </ng-template>
    </ngb-alert>
  `
})
export class NotificationComponent implements AfterViewInit {

  @Input()
  notification: Notification;

  @Input()
  extraCss: string;

  @ViewChild('alert') alert: NgbAlert;

  iconName = '';

  constructor(private router: Router, private store: Store<AppState>) { }

  ngAfterViewInit(): void {
    if (this.notification) {
      this.iconName = NotificationTypes.iconNames[this.notification.type] as string;
      if (this.notification.dismissAfter > 0) {
        setTimeout(() => this.close(), this.notification.dismissAfter);
      }
    }
  }

  close() {
    if (this.notification) {
      this.store.dispatch(removeNotification({ payload: this.notification }));
      this.notification = null;
    }
    this.alert.close();
  }

}
